<template>
	<div class="Top">
		<div class="FromComm">
			<FromComm :FromArr="FromArr"></FromComm>
		</div>
		<SearchComm  placeholder="文件标题名称" @searchClick="searchClick" :width="220" :modelValue="modelValue"></SearchComm>
	</div>
</template>

<script>
	import FromComm from '../../components/fromComponents/Commfrom/from-comm.vue'
	import SearchComm from '../../../../../components/comm-from-search.vue'
	import FromArr from './FromData/FromArr'
	import {
		InformationGetCreatorList
	} from '@/api/home'
	export default {
		components: {
			FromComm,
			SearchComm
		},
		props: {
			modelValue: {
				type: String
			}
		},
		data() {
			return {
				FromArr: [],

			}
		},
		created() {
			this.InformationGetCreatorList()
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
		},
		activated() {},
		updated() {},
		methods: {
			searchClick(val) {
				this.$emit('searchClick', val)
			},
			// 发布人下拉
			async InformationGetCreatorList() {
				let {
					code,
					data,
					message
				} = await InformationGetCreatorList({})
				if (code == 0) {
					this.FromArr[0].options = []
					data.forEach((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArr[0].options.push(obj)
					});
				} else {
					this.$message.warning(message)
				}
			},
		},
		computed: {},
		watch: {},
	}
</script>
<style scoped lang='less'>
	.Top {
		
		height: 64px;
		background: #ffffff;
		border-radius: 4px;
		border: 1px solid #ebedf0;
		
		position: relative;
		user-select: none;

		.FromComm {
			position: relative;
			display: inline-block;
			top: -40px;
			left: 280px;
		}
	}
</style>
